import MultiplexApi from "../server/MultiplexApi.ts";

type OfferCodeFailureReason = "empty" | "format" | "not_found";
type ValidOfferCode = {
  code: string;
  valid: true;
};
type InvalidOfferCode = {
  code: string;
  valid: false;
  reason: OfferCodeFailureReason;
};
export type OfferCodeValidation = ValidOfferCode|InvalidOfferCode;

export function normalizeOfferCode(value: string): string {
  return String(value || "").trim().toUpperCase();
}

export function validateOfferCodeFormat(value: string): InvalidOfferCode | null {
  const code = normalizeOfferCode(value);
  if (!code) return { code, valid: false, reason: "empty" };
  if (!/^[A-Z0-9]{10}$/.test(code)) return { code, valid: false, reason: "format" };
  return null;
}

export async function validateOfferCode(value: string): Promise<OfferCodeValidation> {
  const code = normalizeOfferCode(value);
  const formatError = validateOfferCodeFormat(code);
  if (formatError) return formatError;
  try {
    const isValid = await MultiplexApi.webhomehubvalidatecode(code);
    if (isValid) return { code, valid: true };
    return { code, valid: false, reason: "not_found" };
  } catch (e){
    console.log(e)
    return { code, valid: false, reason: "not_found" };
  }
}

// FizApiPromoCodeExpiredException: the code is unknown or already used.
const PROMO_CODE_EXPIRED_ERROR = "403";

export type HomeHubCheckoutUrl = { checkoutUrl: string | null; failure?: "code_refused" | "error" };

/**
 * Retried once after 1s on an unexpected error: the server has intermittent errors under load.
 * A refused code is not retried.
 */
export async function getHomeHubCheckoutUrl(code: string): Promise<HomeHubCheckoutUrl> {
  for (let attempt = 0; attempt < 2; attempt++) {
    try {
      const result = await MultiplexApi.credit2checkouthomehuburl(code);
      return result.valid && result.checkoutUrl
        ? { checkoutUrl: result.checkoutUrl }
        : { checkoutUrl: null, failure: "code_refused" };
    } catch (e: any){
      console.log(e)
      if (e?.code === PROMO_CODE_EXPIRED_ERROR) return { checkoutUrl: null, failure: "code_refused" };
      if (attempt === 0) await new Promise(resolve => setTimeout(resolve, 1000));
    }
  }
  return { checkoutUrl: null, failure: "error" };
}
